<!--<div class="m-r">-->
  <label for="cname">Select Document Category</label>
  <div class="dropdown-container">
    <button class="btn btn-default dropdown-toggle" type="button" id="menu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      All Document Categories
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu scrollable-menu" role="menu" aria-labelledby="menu1">
      <li role="presentation" *ngFor="let doc of docCategories ">
        <div class="checkbox" role="menuitem">
          <input type="checkbox" style="vertical-align:middle;">
          <label class="checkbox-lbl"> {{doc.DocCatName}}</label>
        </div>
      </li>
    </ul>
  </div>
<!--</div>-->

